import { DEFAULT_LOCALE } from '@cloud/shared/i18n/locale'

/**
 * De actieve taal van de app, voor opmaak buiten een component (kolomdefinities, kleine
 * helpers) waar `useLocale()` niet kan. `Providers` zet hem bij elke render, dus hij volgt de
 * taalkiezer. Zonder dit volgden 116 datums en getallen de taal van de BROWSER in plaats van
 * die van de app (spec 2026-09-26-taalcodes §3.4).
 */
let current: string = DEFAULT_LOCALE

export function setAppLocale(locale: string): void {
  current = locale
}

export function appLocale(): string {
  return current
}
